import { Injectable, inject } from '@angular/core'
import { FeatureToggleServiceConfig, set } from 'feature-toggle-service'
import { EMPTY, filter, first, Observable, tap } from 'rxjs'

import { Company } from '@cyborg-monorepo/hunter/common'

import { AuthService } from '../auth/auth.service'
import { CompanyService } from '../modules/shared/services/company.service'

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private companyService = inject(CompanyService)
  private authService = inject(AuthService)

  private featureToggleData: FeatureToggleServiceConfig = {
    huntModule: false,
    huntRedesign: false,
  }

  private demoCompanyId = 5091 // if dev, insert your company id here

  constructor() {
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        first(),
      )
      .subscribe((user) => {
        this.featureToggleData.huntModule = user.company.huntModuleAccess

        if (user.company.id === this.demoCompanyId) {
          this.featureToggleData.huntRedesign = true
        }

        set(this.featureToggleData as FeatureToggleServiceConfig)
      })
  }

  public loadFeatureFlags(): Observable<Company> {
    if (this.authService.isAuthenticated()) {
      return this.companyService.getCompanyDetails().pipe(
        tap((response) => {
          this.featureToggleData.huntModule = response.huntModuleAccess

          if (response.id === this.demoCompanyId) {
            this.featureToggleData.huntRedesign = true
          }
          set(this.featureToggleData as FeatureToggleServiceConfig)
        }),
      )
    } else {
      return EMPTY
    }
  }

  /**
   * Checks that the user has access to the hunt module
   */
  public huntModuleAccess(): boolean {
    return this.featureToggleData.huntModule
  }

  /**
   * Checks that the user has access to the hunt redesign
   */
  public huntRedesignAccess(): boolean {
    return this.featureToggleData.huntRedesign
  }
}
